export const hasNumberRegexp: RegExp = /\d/;
